import {
  createSortableColumn,
  DataTable,
  type TanstackReactTable,
} from "@devhop/ui";
import { EditIcon } from "lucide-react";
import { RowActions } from "@/shared/ui/RowActions";
import type { OutsourceDTO } from "../../domain/contracts";
import {
  OutsourceActiveBadge,
  OutsourceBankCell,
  OutsourceCategoryBadge,
  OutsourcePayeeCell,
  OutsourcePayeeTypeBadge,
  OutsourcePhoneCell,
} from "./outsource-table-cells";

type OutsourceTableProps = {
  data: OutsourceDTO[];
  isLoading?: boolean;
  offset: number;
  limit: number;
  totalCount: number;
  onPaginationChange: (offset: number, limit: number) => void;
  onEdit: (row: OutsourceDTO) => void;
};

export function OutsourceTable({
  data,
  isLoading,
  offset,
  limit,
  totalCount,
  onPaginationChange,
  onEdit,
}: OutsourceTableProps) {
  const columns: TanstackReactTable.ColumnDef<OutsourceDTO>[] = [
    {
      id: "displayName",
      accessorKey: "displayName",
      header: "ຜູ້ຮັບ",
      cell: ({ row }) => (
        <OutsourcePayeeCell
          displayName={row.original.displayName}
          payeeType={row.original.payeeType}
          contactName={row.original.contactName}
          notes={row.original.notes}
        />
      ),
    },
    {
      id: "category",
      header: "ຫມວດ",
      cell: ({ row }) => (
        <OutsourceCategoryBadge
          name={row.original.categoryName}
          slug={row.original.categorySlug}
        />
      ),
    },
    {
      id: "payeeType",
      header: "ປະເພດ",
      cell: ({ row }) => (
        <OutsourcePayeeTypeBadge payeeType={row.original.payeeType} />
      ),
    },
    {
      id: "phone",
      header: "ເບີໂທ",
      cell: ({ row }) => <OutsourcePhoneCell phone={row.original.phone} />,
    },
    {
      id: "bank",
      header: "ບັນຊີ",
      cell: ({ row }) => (
        <OutsourceBankCell
          bankName={row.original.bankName}
          bankAccount={row.original.bankAccount}
          bankAccountName={row.original.bankAccountName}
        />
      ),
    },
    {
      id: "status",
      header: "ສະຖານະ",
      cell: ({ row }) => (
        <OutsourceActiveBadge isActive={row.original.isActive} />
      ),
    },
    {
      id: "actions",
      size: 72,
      header: "",
      cell: ({ row }) => (
        <RowActions
          actions={[
            {
              label: "ແກ້ໄຂ",
              icon: <EditIcon className="size-4" />,
              onClick: () => onEdit(row.original),
            },
          ]}
        />
      ),
    },
  ];

  return (
    <DataTable<OutsourceDTO, unknown>
      noDataMessage="ບໍ່ພົບ Outsource"
      data={data}
      columns={columns}
      isLoading={isLoading}
      offset={offset}
      limit={limit}
      totalCount={totalCount}
      onPaginationChange={(p) => onPaginationChange(p.offset, p.limit)}
    />
  );
}
